import config from "@/config";
import { usePostXLoginMutation } from "@/queries/auth/mutations";
import { PublicJobOpening } from "@/queries/types";
import styled from "@emotion/styled";
import {
  Button,
  Field,
  Form as LibraryForm,
  TextInput,
} from "@hundred5/design-system";
import { useRouter } from "next/router";
import React, { useState } from "react";
import { PageTitle } from "../page-title";

export function TestLogin({ jobOpening }: { jobOpening: PublicJobOpening }) {
  const router = useRouter();
  const { slug, hashedTestId } = router.query;
  const jobOpeningSlug = slug as string;
  const tesSlug = hashedTestId as string;
  const [email, setEmail] = useState("");
  const testLoginMutation = usePostXLoginMutation();

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    testLoginMutation.mutate(
      {
        data: {
          job_opening_slug: jobOpeningSlug,
          test_slug: tesSlug,
          email: email,
        },
      },
      {
        onSuccess: () => {
          window.location.href = `${config.appUrl}/${jobOpeningSlug}/${tesSlug}?accepted_identity=true`;
        },
      },
    );
  }
  return (
    <Container>
      <PageTitle title={jobOpening?.name} />
      <Form
        header={<h1>Test login</h1>}
        content={
          <>
            <Field
              for="email"
              label="Email:"
              input={
                <TextInput
                  type="text"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.currentTarget.value)}
                />
              }
            />
            <Button type="submit">Log in</Button>
          </>
        }
        onSubmit={handleSubmit}
      />
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

const Form = styled(LibraryForm)`
  width: 450px;

  @media screen and (max-width: 768px) {
    width: 85%;
  }

  & input {
    margin-bottom: 20px;
  }
`;
